import React from 'react';

type AppleIconProps = {
    className?: string;
};

/** Apple logo mark for Sign in with Apple buttons (HIG-compliant sizing). */
export const AppleIcon: React.FC<AppleIconProps> = ({ className = 'h-5 w-5' }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.422-.039-.013-3.176-1.221-3.2-4.873-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.739-2.376-2-.154-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.806-.78.896-1.454 2.338-1.273 3.714 1.32.104 2.686-.562 3.56-1.71z" />
    </svg>
);
